import React from 'react';
import { useLocation } from 'react-router-dom';
import { styled } from '@linaria/react';
import { useTheme, ITheme } from 'src/theme';
import Heading from '@components/Heading';
import Text from '@components/Text';
import { Helpers } from '@utils/helpers';
import cimbLogo from '@assets/images/cimb-logo.png';

const HeadingWrapper = styled.div<HeaderProps>`
  @media screen and (min-width: 768px) {
    h4 {
      text-align: right;
      font-size: ${props => props.theme?.fontSize.label + 'px'};
      color: ${props => props.theme?.colors.white || '  '};
    }
  }
`;

const ContainerGrid = styled.div<HeaderProps>`
  padding: ${props => props.isCIMB ? '8px 20px 5px' : '8px 0 5px' || '8px 20px 5px'};
  margin: 0 auto;
  max-width: 1230px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  flex-direction: ${props => props.isCIMB ? 'row' : 'column'};
  justify-content: ${props => props.isCIMB ? 'space-between' : 'normal'};
  align-items: center;
  @media screen and (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    padding: ${props => props.isCIMB ? '12px 30px 12px' : '12px 30px 12px' || '12px 30px 12px'};
  }
  @media screen and (min-width: 1024px) {
    flex-direction: row;
    justify-content: space-between;
    padding: ${props => props.isCIMB ? '9px 30px 9px' : '11px 30px 11px' || '11px 30px 11px'};
  }
`

const Container = styled.header<HeaderProps>`
  background-color: ${props => props.isCIMB ? '#eee' : props.theme?.colors.primary || ''};
  margin-bottom: ${props => props.isShieldstarter ? "0" : props.isEverGreen ? '24px' : "40px"};
  transition: background 0.3s;
`
const LogoElement = styled.img<HeaderProps>`
  height: 28px;
  position: relative;
  @media screen and (min-width: 768px) {
    height: 36px;
  }
  @media screen and (min-width: 1024px) {
    height: 38px;
  }
`;

const CIMBLogoElement = styled.img<HeaderProps>`
  height: 21px;
  position: relative;
  @media screen and (min-width: 768px) {
    height: 21px;
  }
  @media screen and (min-width: 1024px) {
    height: 21px;
  }
`;

export interface HeaderProps {
  theme?: ITheme;
  planName?: string;
  isCIMB?: boolean;
  isLoading?: boolean;
  isShieldstarter? : boolean;
  isEverGreen?: boolean;
}

export const Header = ({ planName, isCIMB = false}: HeaderProps) => {
  const location = useLocation();
  const theme = useTheme();
  const type: string = Helpers.getTypePlan(location);
  const isShieldstarter = type === 'shieldstarter';
  const isEverGreen = location.pathname.includes('evergreen')
  const getPlanName = () => {
    return (type !== 'mltc') ? Helpers.getPlanName(type) : '';
  }
  return <Container theme={theme} isCIMB={isCIMB} isShieldstarter={isShieldstarter} isEverGreen={isEverGreen}>
    {(
      isCIMB && <ContainerGrid isCIMB={isCIMB}>
        <div>
          <Text fontSize={9} margin={'0 0 3px'}>Distributed by:</Text>
          <CIMBLogoElement src={cimbLogo} />
        </div>
        <HeadingWrapper theme={theme}>
          <Text fontSize={9} margin={'0 0 3px'}>Underwritten by:</Text>
          <CIMBLogoElement src={theme.logoRed} />
        </HeadingWrapper>
      </ContainerGrid>
    )}
    {(
      !isCIMB && <ContainerGrid>
        <LogoElement src={theme.logoWhite} />
        <HeadingWrapper theme={theme}>
          <Heading variant="desc" margin={0} align="center" theme={theme} color={theme.colors.white}> {getPlanName()} </Heading>
        </HeadingWrapper>
      </ContainerGrid>
    )}

  </Container>
};

